import { FC, c } from 'lib/component-utils'
import Container from 'components/landing/Container'
import Heading from 'components/landing/Heading'
import { useUserContext } from 'lib/context'
import { HostType } from 'configs/theme'

import { useIntl } from 'lib/intl-utils'
import Button from 'components/base/Button'
import { useEffect, useRef, useState } from 'react'
import { ChevronLeftIcon, ChevronRightIcon, PlayIcon } from '@heroicons/react/solid'
import { useDraggable } from 'react-use-draggable-scroll'
import * as ScrollArea from '@radix-ui/react-scroll-area'

export const contentByHost: Partial<
  Record<
    HostType,
    Partial<
      Record<
        string,
        {
          heading: string
          text: string
          author: {
            name: string
            role: string
          }
        }[]
      >
    >
  >
> = {
  sellmonitor: {
    ru: [
      {
        heading: 'В MAX можно посмотреть продажи и заказы — пара минут, и всё под рукой.',
        text: 'Пользуюсь сервисом уже второй год. В нём часто появляются новые функции. Сейчас особенно актуальна возможность подключить ИИ-ассистента: удобно зайти в MAX и посмотреть свои продажи и заказы, не заходя на сайт.',
        author: {
          name: 'Дарья Кузнецова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Обновляю себестоимость, а отчёты за прошлые периоды остаются как были',
        text: 'У нас на производстве себестоимость часто меняется. Когда она меняется, я вношу новое значение в сервис, и прошлые периоды не пересчитываются. В отчётах могу смотреть данные по дате заказа или по дате начисления, учитывая налоги и дополнительные расходы. Сервис подключили прежде всего для команды. Я ставлю планы, а коллеги используют аналитику в работе. Раньше мы делали это в таблицах и своих программах, но со временем их перестало хватать.',
        author: {
          name: 'Евгений Мельников',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Репрайсер помогает зарабатывать, а не просто платить комиссию маркетплейсам.',
        text: 'Пользуюсь сервисом с февраля 2026 года. Удобно контролировать основные показатели магазина на Wildberries и Ozon, настроил отправку отчётов в Telegram. Постоянно использую репрайсер: потратил время, чтобы разобраться и всё настроить, но теперь уверен в результате. Сервис подходит продавцам, у которых мало свободного времени — например, есть основная работа, как у меня.',
        author: {
          name: 'Алексей Крылов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Удобно, что всё под рукой: можно посмотреть и свой магазин, и конкурентов.',
        text: 'Пользуюсь сервисом пару месяцев. В целом всё устраивает, хотя есть несколько некритичных нюансов, которые хотелось бы доработать. Сначала не поняла, как пользоваться репрайсером, но в поддержке быстро объяснили. Цифры сходятся, а если что-то не совпадает, поддержка оперативно помогает и исправляет ошибки.',
        author: {
          name: 'Анастасия Морозова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Биддер помогает оптимизировать и время, и рекламный бюджет.',
        text: 'Через год после открытия магазина на Wildberries обороты выросли, а понимания, как учитывать все расходы и запускать рекламу, не хватало. О сервисе рассказал знакомый продавец, и я сходила на встречу с аналитиком. Рекламу запускала редко, поэтому к биддеру сначала отнеслась с недоверием. Но после пары тестовых дней поняла, что он действительно помогает экономить и время, и бюджет. Внутренняя аналитика тоже нравится, а если возникают вопросы, поддержка всегда на связи.',
        author: {
          name: 'Дарья Чернова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading:
          'ИИ-агент присылает сводку по магазину в Telegram и экономит время на поиске данных.',
        text: 'Пользуюсь сервисом полгода. В основном работаю с финансовой аналитикой, репрайсером и SEO-инструментами, иногда — с биддером. Цифры неоднократно сравнивал с финансовыми отчётами Wildberries — совпадают. Последним начал использовать ИИ-агента: по моему запросу в Telegram приходит сводка продаж, заказов и расходов. Удобно получать информацию по кабинету, не разыскивая её самостоятельно.',
        author: {
          name: 'Леонид Фомин',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Больше всего нравится внутренняя аналитика.',
        text: 'Удобно смотреть продажи, расходы и прибыль по товарам, понимать, что приносит деньги и где нужно что-то скорректировать. Полезны репрайсер для управления ценами и SEO-инструменты для подбора запросов и доработки карточек. Всё собрано в одном месте — это упрощает ежедневную работу с магазином. Функций много, поначалу нужно разобраться, но потом понимаешь, какие инструменты нужны именно под твои задачи.',
        author: {
          name: 'Александр Павлов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Сервис помогает принимать решения на основе цифр, а не догадок.',
        text: 'Пользуюсь внутренней аналитикой и слежу за показателями магазина на Wildberries. В одном месте удобно смотреть продажи, выручку и динамику по товарам. Можно быстро понять, какие карточки растут, где началась просадка и какие позиции нужно срочно пополнить. Не приходится собирать данные вручную из разных отчётов личного кабинета. Для продавца, который ежедневно следит за ассортиментом и продажами, это полезный инструмент.',
        author: {
          name: 'Ярослав Громов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Все основные показатели в одном месте — сразу видно, где просели продажи.',
        text: 'Пользуюсь сервисом уже несколько месяцев. Раньше приходилось постоянно переключаться между разными отчётами и тратить время на анализ. Сейчас сразу видно, на что обратить внимание. Интерфейс понятный, ничего лишнего. Сервис облегчает работу, особенно когда товаров много.',
        author: {
          name: 'Константин Белов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'С оптимальной ставкой наконец нашла биддер, который мне подходит.',
        text: 'Долго искала инструмент, который не выставляет максимальную ставку сразу после запуска. В других биддерах попытки занять заданную высокую позицию не давали результата — проще было управлять рекламой самой. Когда протестировала оптимальную ставку, наконец нашла то, что искала: биддер выставляет адекватные ставки и удерживает нужные позиции. Теперь трачу меньше времени на рекламу и больше — на SEO-оптимизацию. Другие инструменты тоже хорошие, но биддер стал моим спасением.',
        author: {
          name: 'Мария Соколова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Удобный универсальный инструмент для всей команды.',
        text: 'В аналитике конкурентов, на мой взгляд, одни из самых реалистичных цифр. Удобно следить за лидерами своей ниши и подробно разбирать их товары. Часто выгружаю отзывы, чтобы найти недостатки популярных товаров и показать на инфографике, что у наших таких проблем нет. Как контент- и ORM-менеджер, также пользуюсь автоответами на отзывы: текст можно написать самостоятельно или сгенерировать. Коллеги используют сервис для своих задач.',
        author: {
          name: 'Андрей Власов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Автоответы по шаблонам и с помощью ИИ заметно снижают нагрузку на отдел.',
        text: 'С коллегами выбирали сервис для ответов на отзывы на Ozon и Wildberries. Тестировали разные решения и случайно нашли этот сервис. Понравилось, что ответы можно настроить и по своим шаблонам, и с помощью ИИ. Потом изучили другие функции: репрайсер с большим количеством настроек и внешнюю аналитику для работы с конкурентами. Интерфейс приятный и понятный. Из всех сервисов для работы с маркетплейсами, которые мы пробовали, этот — лучший. Рекомендую!',
        author: {
          name: 'Дарья Тихонова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Легко настроил поведение ИИ под стиль общения компании.',
        text: 'Как ORM-специалисту, мне было важно наладить управление репутацией бренда и снизить операционную нагрузку. Долго искал решение для работы с обратной связью покупателей без потери доверия аудитории. В сервисе нашёл интуитивно понятный инструмент автоответов на отзывы: настроил поведение ИИ под стиль общения компании и задал нужные параметры. Спасибо команде за полезный сервис!',
        author: {
          name: 'Илья Захаров',
          role: 'Индивидуальный предприниматель',
        },
      },
    ],
  },
  uzum: {
    uz: [
      {
        heading:
          'MAX orqali sotuvlar va buyurtmalarni ko‘rish mumkin — bir-ikki daqiqada hammasi qo‘l ostida.',
        text: 'Servisdan ikkinchi yil foydalanayapman. Unda tez-tez yangi funksiyalar paydo bo‘ladi. Hozir ayniqsa sun’iy intellekt yordamchisini ulash imkoniyati juda qo‘l kelmoqda: saytga kirmasdan, MAX orqali sotuvlar va buyurtmalarni ko‘rish qulay.',
        author: {
          name: 'Darya Kuznetsova',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading: 'Tannarxni yangilayman, oldingi davr hisobotlari esa o‘zgarishsiz qoladi',
        text: 'Ishlab chiqarishimizda tannarx tez-tez o‘zgaradi. O‘zgarganda servisga yangi qiymatni kiritaman, oldingi davrlar uchun esa ma’lumotlar qayta hisoblanmaydi. Hisobotlarda soliqlar va qo‘shimcha xarajatlarni hisobga olgan holda ma’lumotlarni buyurtma sanasi yoki hisoblash sanasi bo‘yicha ko‘ra olaman. Servisni avvalo jamoa uchun uladik. Men rejalarni belgilayman, hamkasblarim esa ishda tahliliy ma’lumotlardan foydalanadi. Ilgari buni jadvallar va o‘z dasturlarimiz yordamida qilardik, lekin vaqt o‘tishi bilan ular yetarli bo‘lmay qoldi.',
        author: {
          name: 'Yevgeniy Melnikov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Reprayser marketpleyslarga shunchaki komissiya to‘lash emas, daromad olishga yordam beradi.',
        text: 'Servisdan 2026-yil fevralidan beri foydalanaman. Wildberries va Ozon do‘konlarining asosiy ko‘rsatkichlarini nazorat qilish qulay, hisobotlarni Telegram orqali yuborishni ham sozlab oldim. Reprayserdan doim foydalanaman: uni tushunish va hammasini sozlashga vaqt sarfladim, lekin endi natijaga ishonchim komil. Servis bo‘sh vaqti kam sotuvchilarga, masalan, men kabi asosiy ish joyi borlarga mos keladi.',
        author: {
          name: 'Aleksey Krilov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Hammasi qo‘l ostida bo‘lgani qulay: o‘z do‘koningizni ham, raqobatchilarni ham ko‘rish mumkin.',
        text: 'Servisdan bir-ikki oydan beri foydalanaman. Umuman olganda, hammasi ma’qul, garchi yaxshilashni istagan ayrim kichik jihatlar bo‘lsa ham. Avvaliga reprayserdan qanday foydalanishni tushunmadim, lekin qo‘llab-quvvatlash xizmati tezda tushuntirib berdi. Raqamlar mos keladi, biror narsa mos kelmasa, qo‘llab-quvvatlash xizmati tez yordam beradi va xatolarni tuzatadi.',
        author: {
          name: 'Anastasiya Morozova',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading: 'Bidder vaqtni ham, reklama budjetini ham samaraliroq sarflashga yordam beradi.',
        text: 'Wildberries’da do‘kon ochganimdan bir yil o‘tib, savdo hajmi oshdi, ammo barcha xarajatlarni qanday hisobga olish va reklamani qanday yo‘lga qo‘yish haqida bilimim yetarli emasdi. Servis haqida tanish sotuvchi aytib berdi va men tahlilchi bilan uchrashuvga bordim. Reklamani kam yoqardim, shu sababli bidderga avvaliga ishonchsizlik bilan qaradim. Lekin bir-ikki kun sinab ko‘rgach, u vaqtni ham, budjetni ham tejashga haqiqatan yordam berishini tushundim. Ichki tahlil ham yoqadi, savollar tug‘ilsa, qo‘llab-quvvatlash xizmati doim aloqada.',
        author: {
          name: 'Darya Chernova',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Sun’iy intellekt agenti Telegram’ga do‘kon bo‘yicha jamlanma yuborib, ma’lumot qidirishga ketadigan vaqtni tejaydi.',
        text: 'Servisdan yarim yildan beri foydalanaman. Asosan moliyaviy tahlil, reprayser va SEO vositalari bilan ishlayman, ba’zan bidderdan ham foydalanaman. Raqamlarni Wildberries moliyaviy hisobotlari bilan bir necha bor solishtirganman — mos keladi. Eng oxirida sun’iy intellekt agentidan foydalanishni boshladim: so‘rovim bo‘yicha Telegram’ga sotuvlar, buyurtmalar va xarajatlar jamlanmasi keladi. Kabinet bo‘yicha ma’lumotni o‘zim qidirib yurmasdan olish qulay.',
        author: {
          name: 'Leonid Fomin',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading: 'Menga eng ko‘p ichki tahlil yoqadi.',
        text: 'Mahsulotlar bo‘yicha sotuvlar, xarajatlar va foydani ko‘rish, nima daromad keltirayotganini va qayerda o‘zgartirish kerakligini tushunish qulay. Narxlarni boshqarish uchun reprayser, so‘rovlarni tanlash va mahsulot kartalarini yaxshilash uchun SEO vositalari foydali. Hammasi bir joyda jamlangan — bu do‘kon bilan kundalik ishlashni osonlashtiradi. Funksiyalar ko‘p, boshida ularni o‘rganish kerak, keyin esa aynan o‘z vazifalaringiz uchun qaysi vositalar kerakligini tushunasiz.',
        author: {
          name: 'Aleksandr Pavlov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Servis taxminlarga emas, raqamlarga asoslanib qaror qabul qilishga yordam beradi.',
        text: 'Ichki tahlildan foydalanaman va Wildberries’dagi do‘kon ko‘rsatkichlarini kuzataman. Sotuvlar, tushum va mahsulotlar bo‘yicha o‘zgarishlarni bir joyda ko‘rish qulay. Qaysi kartalar o‘sayotganini, qayerda pasayish boshlanganini va qaysi mahsulotlar zaxirasini zudlik bilan to‘ldirish kerakligini tezda tushunish mumkin. Shaxsiy kabinetdagi turli hisobotlardan ma’lumotlarni qo‘lda yig‘ishga hojat qolmaydi. Assortiment va sotuvlarni har kuni kuzatadigan sotuvchi uchun bu foydali vosita.',
        author: {
          name: 'Yaroslav Gromov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Barcha asosiy ko‘rsatkichlar bir joyda — sotuvlar qayerda pasaygani darrov ko‘rinadi.',
        text: 'Servisdan bir necha oydan beri foydalanaman. Oldin doim turli hisobotlar o‘rtasida o‘tib yurishga va tahlilga vaqt sarflashga to‘g‘ri kelardi. Hozir nimaga e’tibor berish kerakligi darrov ko‘rinadi. Interfeys tushunarli, ortiqcha narsa yo‘q. Servis ishni yengillashtiradi, ayniqsa mahsulotlar ko‘p bo‘lsa.',
        author: {
          name: 'Konstantin Belov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading: 'Optimal stavka bilan nihoyat o‘zimga mos bidderni topdim.',
        text: 'Ishga tushishi bilanoq eng yuqori stavkani qo‘ymaydigan vositani uzoq izladim. Boshqa bidderlarda belgilangan yuqori o‘rinni egallashga urinishlar natija bermasdi — reklamani o‘zim boshqarganim osonroq edi. Optimal stavkani sinab ko‘rgach, nihoyat izlaganimni topdim: bidder maqbul stavkalarni belgilaydi va kerakli o‘rinlarni ushlab turadi. Endi reklamaga kamroq, SEO optimallashtirishga esa ko‘proq vaqt sarflayman. Boshqa vositalar ham yaxshi, lekin bidder men uchun najot bo‘ldi.',
        author: {
          name: 'Mariya Sokolova',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading: 'Butun jamoa uchun qulay va universal vosita.',
        text: 'Menimcha, raqobatchilar tahlilidagi raqamlar eng haqqoniylaridan biri. O‘z yo‘nalishingizdagi yetakchilarni kuzatish va ularning mahsulotlarini batafsil tahlil qilish qulay. Ommabop mahsulotlarning kamchiliklarini topish va infografikada bizning mahsulotlarimizda bunday muammolar yo‘qligini ko‘rsatish uchun xaridorlar sharhlarini tez-tez yuklab olaman. Kontent va ORM menejeri sifatida sharhlarga avtomatik javob berishdan ham foydalanaman: matnni o‘zingiz yozishingiz yoki generatsiya qilishingiz mumkin. Hamkasblarim servisdan o‘z vazifalari uchun foydalanadi.',
        author: {
          name: 'Andrey Vlasov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Shablonlar va sun’iy intellekt yordamidagi avtomatik javoblar bo‘lim ish yukini sezilarli kamaytiradi.',
        text: 'Hamkasblarim bilan Ozon va Wildberries’dagi sharhlarga javob berish uchun servis tanlayotgandik. Turli yechimlarni sinab ko‘rib, tasodifan shu servisni topdik. Javoblarni o‘z shablonlarimiz bo‘yicha ham, sun’iy intellekt yordamida ham sozlash mumkinligi yoqdi. Keyin boshqa funksiyalarni ham o‘rgandik: ko‘plab sozlamalarga ega reprayser va raqobatchilar bilan ishlash uchun tashqi tahlil. Interfeys yoqimli va tushunarli. Biz sinab ko‘rgan marketpleyslar bilan ishlash servislarining eng yaxshisi shu. Tavsiya qilaman!',
        author: {
          name: 'Darya Tixonova',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
      {
        heading:
          'Sun’iy intellektning javob berish uslubini kompaniyamiz muloqot uslubiga oson moslashtirdim.',
        text: 'ORM mutaxassisi sifatida men uchun brend obro‘sini boshqarishni yo‘lga qo‘yish va kundalik ish yukini kamaytirish muhim edi. Auditoriya ishonchini yo‘qotmasdan xaridorlar fikr-mulohazalari bilan ishlash uchun yechimni uzoq izladim. Servisda sharhlarga avtomatik javob berish uchun intuitiv va tushunarli vositani topdim: sun’iy intellektning javob berish uslubini kompaniyamiz muloqot uslubiga moslashtirib, kerakli parametrlarni belgiladim. Foydali servis uchun jamoaga rahmat!',
        author: {
          name: 'Ilya Zaxarov',
          role: 'Yakka tartibdagi tadbirkor',
        },
      },
    ],
    ru: [
      {
        heading: 'В MAX можно посмотреть продажи и заказы — пара минут, и всё под рукой.',
        text: 'Пользуюсь сервисом уже второй год. В нём часто появляются новые функции. Сейчас особенно актуальна возможность подключить ИИ-ассистента: удобно зайти в MAX и посмотреть свои продажи и заказы, не заходя на сайт.',
        author: {
          name: 'Дарья Кузнецова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Обновляю себестоимость, а отчёты за прошлые периоды остаются как были',
        text: 'У нас на производстве себестоимость часто меняется. Когда она меняется, я вношу новое значение в сервис, и прошлые периоды не пересчитываются. В отчётах могу смотреть данные по дате заказа или по дате начисления, учитывая налоги и дополнительные расходы. Сервис подключили прежде всего для команды. Я ставлю планы, а коллеги используют аналитику в работе. Раньше мы делали это в таблицах и своих программах, но со временем их перестало хватать.',
        author: {
          name: 'Евгений Мельников',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Репрайсер помогает зарабатывать, а не просто платить комиссию маркетплейсам.',
        text: 'Пользуюсь сервисом с февраля 2026 года. Удобно контролировать основные показатели магазина на Wildberries и Ozon, настроил отправку отчётов в Telegram. Постоянно использую репрайсер: потратил время, чтобы разобраться и всё настроить, но теперь уверен в результате. Сервис подходит продавцам, у которых мало свободного времени — например, есть основная работа, как у меня.',
        author: {
          name: 'Алексей Крылов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Удобно, что всё под рукой: можно посмотреть и свой магазин, и конкурентов.',
        text: 'Пользуюсь сервисом пару месяцев. В целом всё устраивает, хотя есть несколько некритичных нюансов, которые хотелось бы доработать. Сначала не поняла, как пользоваться репрайсером, но в поддержке быстро объяснили. Цифры сходятся, а если что-то не совпадает, поддержка оперативно помогает и исправляет ошибки.',
        author: {
          name: 'Анастасия Морозова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Биддер помогает оптимизировать и время, и рекламный бюджет.',
        text: 'Через год после открытия магазина на Wildberries обороты выросли, а понимания, как учитывать все расходы и запускать рекламу, не хватало. О сервисе рассказал знакомый продавец, и я сходила на встречу с аналитиком. Рекламу запускала редко, поэтому к биддеру сначала отнеслась с недоверием. Но после пары тестовых дней поняла, что он действительно помогает экономить и время, и бюджет. Внутренняя аналитика тоже нравится, а если возникают вопросы, поддержка всегда на связи.',
        author: {
          name: 'Дарья Чернова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading:
          'ИИ-агент присылает сводку по магазину в Telegram и экономит время на поиске данных.',
        text: 'Пользуюсь сервисом полгода. В основном работаю с финансовой аналитикой, репрайсером и SEO-инструментами, иногда — с биддером. Цифры неоднократно сравнивал с финансовыми отчётами Wildberries — совпадают. Последним начал использовать ИИ-агента: по моему запросу в Telegram приходит сводка продаж, заказов и расходов. Удобно получать информацию по кабинету, не разыскивая её самостоятельно.',
        author: {
          name: 'Леонид Фомин',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Больше всего нравится внутренняя аналитика.',
        text: 'Удобно смотреть продажи, расходы и прибыль по товарам, понимать, что приносит деньги и где нужно что-то скорректировать. Полезны репрайсер для управления ценами и SEO-инструменты для подбора запросов и доработки карточек. Всё собрано в одном месте — это упрощает ежедневную работу с магазином. Функций много, поначалу нужно разобраться, но потом понимаешь, какие инструменты нужны именно под твои задачи.',
        author: {
          name: 'Александр Павлов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Сервис помогает принимать решения на основе цифр, а не догадок.',
        text: 'Пользуюсь внутренней аналитикой и слежу за показателями магазина на Wildberries. В одном месте удобно смотреть продажи, выручку и динамику по товарам. Можно быстро понять, какие карточки растут, где началась просадка и какие позиции нужно срочно пополнить. Не приходится собирать данные вручную из разных отчётов личного кабинета. Для продавца, который ежедневно следит за ассортиментом и продажами, это полезный инструмент.',
        author: {
          name: 'Ярослав Громов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Все основные показатели в одном месте — сразу видно, где просели продажи.',
        text: 'Пользуюсь сервисом уже несколько месяцев. Раньше приходилось постоянно переключаться между разными отчётами и тратить время на анализ. Сейчас сразу видно, на что обратить внимание. Интерфейс понятный, ничего лишнего. Сервис облегчает работу, особенно когда товаров много.',
        author: {
          name: 'Константин Белов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'С оптимальной ставкой наконец нашла биддер, который мне подходит.',
        text: 'Долго искала инструмент, который не выставляет максимальную ставку сразу после запуска. В других биддерах попытки занять заданную высокую позицию не давали результата — проще было управлять рекламой самой. Когда протестировала оптимальную ставку, наконец нашла то, что искала: биддер выставляет адекватные ставки и удерживает нужные позиции. Теперь трачу меньше времени на рекламу и больше — на SEO-оптимизацию. Другие инструменты тоже хорошие, но биддер стал моим спасением.',
        author: {
          name: 'Мария Соколова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Удобный универсальный инструмент для всей команды.',
        text: 'В аналитике конкурентов, на мой взгляд, одни из самых реалистичных цифр. Удобно следить за лидерами своей ниши и подробно разбирать их товары. Часто выгружаю отзывы, чтобы найти недостатки популярных товаров и показать на инфографике, что у наших таких проблем нет. Как контент- и ORM-менеджер, также пользуюсь автоответами на отзывы: текст можно написать самостоятельно или сгенерировать. Коллеги используют сервис для своих задач.',
        author: {
          name: 'Андрей Власов',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Автоответы по шаблонам и с помощью ИИ заметно снижают нагрузку на отдел.',
        text: 'С коллегами выбирали сервис для ответов на отзывы на Ozon и Wildberries. Тестировали разные решения и случайно нашли этот сервис. Понравилось, что ответы можно настроить и по своим шаблонам, и с помощью ИИ. Потом изучили другие функции: репрайсер с большим количеством настроек и внешнюю аналитику для работы с конкурентами. Интерфейс приятный и понятный. Из всех сервисов для работы с маркетплейсами, которые мы пробовали, этот — лучший. Рекомендую!',
        author: {
          name: 'Дарья Тихонова',
          role: 'Индивидуальный предприниматель',
        },
      },
      {
        heading: 'Легко настроил поведение ИИ под стиль общения компании.',
        text: 'Как ORM-специалисту, мне было важно наладить управление репутацией бренда и снизить операционную нагрузку. Долго искал решение для работы с обратной связью покупателей без потери доверия аудитории. В сервисе нашёл интуитивно понятный инструмент автоответов на отзывы: настроил поведение ИИ под стиль общения компании и задал нужные параметры. Спасибо команде за полезный сервис!',
        author: {
          name: 'Илья Захаров',
          role: 'Индивидуальный предприниматель',
        },
      },
    ],
  },
}

function QuoteIcon(props: any) {
  return (
    <svg aria-hidden="true" width={105} height={78} {...props}>
      <path d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Zm54.24 0c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622-2.11-4.52-3.164-9.643-3.164-15.368 0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C82.565 3.917 87.839 1.507 93.564 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z" />
    </svg>
  )
}

const VideoTestimonial: FC<
  { id: string; image: string; name: string; isOpened: boolean },
  'iframe'
> = ({ id: passedId, image, name, className, isOpened, ...rest }) => {
  const [oid, id] = passedId.split('_')

  return (
    <div className={c`shrink-0 relative select-none ${className}`} {...rest}>
      {isOpened && (
        <iframe
          src={`https://vk.com/video_ext.php?oid=-${oid}&id=${id}`}
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
          allowFullScreen
          className={c`rounded-xl ring ring-1 ring-inset ring-black/5 w-[270px] h-[480px]`}
        />
      )}
      {!isOpened && (
        <>
          <img
            src={`/next/img/landing/testimonials/${image}.jpg`}
            alt={name}
            className="rounded-xl shrink-0 w-[270px] h-[480px] ring ring-inset ring-1 ring-black/5 object-cover"
          />
          <div className="absolute inset-0 transition-shadow duration-200 cursor-pointer group">
            <div className="flex items-end justify-start w-full h-full">
              <span className="px-3 py-1 m-4 text-base font-medium text-black bg-white rounded-md">
                {name}
              </span>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <PlayIcon className="w-16 h-16 text-white transition-opacity duration-200 opacity-0 group-hover:opacity-100" />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const sellmonitorVideoTestimonials = [
  //{ image: '2zOhdzyFZx8', name: 'Екатерина' },
  { id: '212594941_456239042', image: '3f_j49xizIU', name: 'Любовь' },
  { id: '212594941_456239053', image: 'hCgaR6ByJTw', name: 'Богдан' },
  { id: '212594941_456239044', image: 'PzXCy3r4sT4', name: 'Евгения' },
  { id: '212594941_456239063', image: 'aleksandr', name: 'Александр' },
  //{ image: 'd_QcpDcP0d4', name: 'Ксения' },
  { id: '212594941_456239046', image: 'DTmBsQrwDMo', name: 'Анна' },
  { id: '212594941_456239059', image: 'alisa', name: 'Алиса' },
  { id: '212594941_456239041', image: 'Oal0mCF1TwA', name: 'Наталья' },
  { id: '212594941_456239043', image: 'hklycbNwD5Q', name: 'Эльвира' },
]

type Props = {
  headingClassName?: string
}

const Testimonials: FC<Props> = ({ className, headingClassName }) => {
  const ctx = useUserContext()
  const { lang, t } = useIntl()
  const isVisible = ctx.theme.hostType !== 'sellscreen'
  const [openedTestimonial, setOpenedTestimonial] = useState<string | null>(null)
  const videoScrollAreaRef = useRef<HTMLDivElement>(null)
  const textScrollAreaRef = useRef<HTMLDivElement>(null)
  const { events: videoDragEvents } = useDraggable(videoScrollAreaRef as any, {
    isMounted: isVisible,
  })
  const { events: textDragEvents } = useDraggable(textScrollAreaRef as any, {
    isMounted: isVisible,
  })
  const [videoScrollState, setVideoScrollState] = useState({
    atStart: true,
    atEnd: false,
    hasOverflow: false,
  })
  const [textScrollState, setTextScrollState] = useState({
    atStart: true,
    atEnd: false,
    hasOverflow: false,
  })

  useEffect(() => {
    const viewport = videoScrollAreaRef.current
    if (!viewport) return

    const updateScrollState = () => {
      const hasOverflow = viewport.scrollWidth > viewport.clientWidth + 1
      setVideoScrollState({
        atStart: viewport.scrollLeft <= 1,
        atEnd:
          !hasOverflow || viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1,
        hasOverflow,
      })
    }

    updateScrollState()
    viewport.addEventListener('scroll', updateScrollState)
    const observer = new ResizeObserver(updateScrollState)
    observer.observe(viewport)

    return () => {
      viewport.removeEventListener('scroll', updateScrollState)
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    const viewport = textScrollAreaRef.current
    if (!viewport) return

    const updateScrollState = () => {
      const hasOverflow = viewport.scrollWidth > viewport.clientWidth + 1
      setTextScrollState({
        atStart: viewport.scrollLeft <= 1,
        atEnd:
          !hasOverflow || viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1,
        hasOverflow,
      })
    }

    updateScrollState()
    viewport.addEventListener('scroll', updateScrollState)
    const observer = new ResizeObserver(updateScrollState)
    observer.observe(viewport)

    return () => {
      viewport.removeEventListener('scroll', updateScrollState)
      observer.disconnect()
    }
  }, [])

  const scrollToAdjacentTestimonial = (
    viewport: HTMLDivElement | null,
    direction: 'left' | 'right'
  ) => {
    if (!viewport) return

    const items = Array.from(viewport.querySelectorAll<HTMLElement>('[data-testimonial-item]'))
    const firstItemOffset = items[0]?.offsetLeft ?? 0
    const currentItemIndex = items.reduce(
      (index, item, itemIndex) =>
        item.offsetLeft <= viewport.scrollLeft + firstItemOffset + 1 ? itemIndex : index,
      0
    )
    const item = items[currentItemIndex + (direction === 'left' ? -1 : 1)]

    viewport.scrollTo({
      left: item
        ? item.offsetLeft - firstItemOffset
        : direction === 'left'
          ? 0
          : viewport.scrollWidth,
      behavior: 'smooth',
    })
  }

  if (!isVisible) return null
  const content = contentByHost[ctx.theme.hostType]![lang]!

  return (
    <Container className={className}>
      <Heading
        className={headingClassName}
        tagline={lang === 'uz' ? 'Odamlar biz haqimizda nima deyishadi' : 'Что люди говорят о нас'}
      />
      <ScrollArea.Root type="always" className="w-full h-full max-w-full max-h-full">
        <ScrollArea.Viewport
          ref={videoScrollAreaRef}
          className="w-full h-full select-none overscroll-x-contain cursor-grab"
          {...videoDragEvents}
        >
          <div className="flex p-1 mt-8 space-x-3">
            {sellmonitorVideoTestimonials.map((testimonial) => (
              <VideoTestimonial
                key={testimonial.id}
                id={testimonial.id}
                image={testimonial.image}
                name={testimonial.name}
                isOpened={openedTestimonial === testimonial.id}
                data-testimonial-item
                onClick={() => setOpenedTestimonial(testimonial.id)}
              />
            ))}
          </div>
        </ScrollArea.Viewport>
        {videoScrollState.hasOverflow && (
          <ScrollArea.Scrollbar
            orientation="horizontal"
            className="flex w-full h-1.5 -mb-2 bg-gray-200 rounded-full"
          >
            <ScrollArea.Thumb className="w-10 h-1.5 transition-colors ease-in-out bg-gray-400 rounded-full hover:bg-gray-500" />
          </ScrollArea.Scrollbar>
        )}
        <ScrollArea.Corner />
      </ScrollArea.Root>
      {videoScrollState.hasOverflow && (
        <div className="flex justify-center gap-2 mt-5">
          <Button
            theme="gray"
            aria-label={t`scroll_left`}
            className="!rounded-full !px-2 disabled:hover:!bg-transparent disabled:hover:!text-primary-600 !ring-0 !ring-offset-0 !ring-transparent"
            disabled={videoScrollState.atStart}
            onClick={() => scrollToAdjacentTestimonial(videoScrollAreaRef.current, 'left')}
          >
            <ChevronLeftIcon className="size-6 shrink-0" />
          </Button>
          <Button
            theme="gray"
            aria-label={t`scroll_right`}
            className="!rounded-full !px-2 disabled:hover:!bg-transparent disabled:hover:!text-primary-600 !ring-0 !ring-offset-0 !ring-transparent"
            disabled={videoScrollState.atEnd}
            onClick={() => scrollToAdjacentTestimonial(videoScrollAreaRef.current, 'right')}
          >
            <ChevronRightIcon className="size-6 shrink-0" />
          </Button>
        </div>
      )}
      <ScrollArea.Root type="always" className="w-full h-full max-w-full max-h-full">
        <ScrollArea.Viewport
          ref={textScrollAreaRef}
          className="w-full h-full select-none overscroll-x-contain"
          {...textDragEvents}
        >
          <ul role="list" className="flex gap-6 mt-16 sm:gap-8 lg:mt-20">
            {content.map((testimonial, testimonialIndex) => (
              <li
                key={testimonialIndex}
                data-testimonial-item
                className="w-[calc(100dvw-2rem)] sm:w-[384px] shrink-0"
              >
                <figure className="relative p-6 bg-white border border-gray-200 rounded-2xl">
                  <QuoteIcon className="absolute top-6 left-6 fill-slate-100" />
                  <blockquote className="relative">
                    <p className="text-lg text-black">{testimonial.heading}</p>
                    <p className="mt-4 text-base text-gray-600">{testimonial.text}</p>
                  </blockquote>
                  <figcaption className="relative pt-6 mt-6 border-t border-slate-100">
                    <div>
                      <div className="text-base font-display text-slate-900">
                        {testimonial.author.name}
                      </div>
                      {testimonial.author.role && (
                        <div className="mt-1 text-sm text-slate-500">{testimonial.author.role}</div>
                      )}
                    </div>
                  </figcaption>
                </figure>
              </li>
            ))}
          </ul>
        </ScrollArea.Viewport>
        {textScrollState.hasOverflow && (
          <ScrollArea.Scrollbar
            orientation="horizontal"
            className="flex w-full h-1.5 -mb-2 bg-gray-200 rounded-full"
          >
            <ScrollArea.Thumb className="w-10 h-1.5 transition-colors ease-in-out bg-gray-400 rounded-full hover:bg-gray-500" />
          </ScrollArea.Scrollbar>
        )}
        <ScrollArea.Corner />
      </ScrollArea.Root>
      {textScrollState.hasOverflow && (
        <div className="flex justify-center gap-2 mt-5">
          <Button
            theme="gray"
            aria-label={t`scroll_left`}
            className="!rounded-full !px-2 disabled:hover:!bg-transparent disabled:hover:!text-primary-600 !ring-0 !ring-offset-0 !ring-transparent"
            disabled={textScrollState.atStart}
            onClick={() => scrollToAdjacentTestimonial(textScrollAreaRef.current, 'left')}
          >
            <ChevronLeftIcon className="size-6 shrink-0" />
          </Button>
          <Button
            theme="gray"
            aria-label={t`scroll_right`}
            className="!rounded-full !px-2 disabled:hover:!bg-transparent disabled:hover:!text-primary-600 !ring-0 !ring-offset-0 !ring-transparent"
            disabled={textScrollState.atEnd}
            onClick={() => scrollToAdjacentTestimonial(textScrollAreaRef.current, 'right')}
          >
            <ChevronRightIcon className="size-6 shrink-0" />
          </Button>
        </div>
      )}
    </Container>
  )
}

export default Testimonials
